module.exports = __webpack_public_path__ + "img/sprite_2.fc2e4043.png";